import { Component, CustomElement } from "../../core/CustomElement";

@Component("ccc-html-panel", {
  template: require("./template.html").default,
  style: require("./style.scss").default,
})
export default class CCCHtmlPanel extends CustomElement {
  constructor() {
    super();
    this.loading = true;
  }

  watchHtml(): void {
    this.shadowDom.querySelector(".ccc-html-panel-container").innerHTML =
      this.state.html;
  }
}
